import { useEffect } from 'react';
import Cookies from 'universal-cookie';
import { DEV_ONBOARDING_SESSION_PRODUCT_ID, PROD_ONBOARDING_SESSION_PRODUCT_ID } from './Pricing/constants';

const PersonalSetupRedirect = () => {

  useEffect(() => {

    const cookies = new Cookies();
    const clientId = cookies.get('client_id');

    const conciergePaymentProductId = process.env.NODE_ENV === 'production'
      ? PROD_ONBOARDING_SESSION_PRODUCT_ID
      : DEV_ONBOARDING_SESSION_PRODUCT_ID;

    window.location.href = `https://buy.stripe.com/${conciergePaymentProductId}?client_reference_id=${clientId}`;
  }, []);

  return null;
};

export default PersonalSetupRedirect;
